<template>
  <div class="carousel-container" >
    <el-carousel style="height: 86.5vh;" direction="vertical" indicator-position="none" :autoplay="false"  arrow="always"  :loop="false"
      ref="carousel"  >
      <el-carousel-item>
        <img src="../assets/img/home_top.png" alt="">
      </el-carousel-item>
      <el-carousel-item>
        <img src="../assets/img/home_do.png" alt="">
      </el-carousel-item>
      <el-carousel-item>
        <img src="../assets/img/home_anli.png" alt="">
      </el-carousel-item>
    </el-carousel>
    <!-- <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one" style="height: 800px !important;">
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three">
      </swiper-slide>
    </swiper> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      scrollTimeout: null, // 用于存储定时器的 ID 
      }
  },
  mounted() {  
    this.$refs.carousel.$el.addEventListener('wheel', this.handleWheel);  
  },  
  beforeDestroy() {  
    this.$refs.carousel.$el.removeEventListener('wheel', this.handleWheel);
    if (this.scrollTimeout) {  
      clearTimeout(this.scrollTimeout);  
    }  
  },  
  methods: {  
    handleWheel(event) {  
      // 清除之前的定时器（如果有的话）  
      if (this.scrollTimeout) {  
        clearTimeout(this.scrollTimeout);  
      }  
  
      // 设置一个新的定时器，以延迟执行切换  
      this.scrollTimeout = setTimeout(() => {  
        const delta = event.deltaY;  
        if (delta < 0) {  
          // 向上滚动，但不确定是否已经能切换到下一张  
          // 这里可以调用自定义的 checkAndNext 方法来检查并切换  
          this.checkAndNext();  
        } else {  
          // 向下滚动，同样调用自定义的 checkAndPrev 方法  
          this.checkAndPrev();  
        }  
      }, 100); // 延迟 100 毫秒，这个值可以根据需要调整  
    },  
    checkAndNext() {  
      // 这里应该有一个逻辑来检查是否应该切换到下一张  
      // 但由于 Element UI 没有直接提供 API，这里假设你总是可以切换  
      
      this.$refs.carousel.prev();
    },  
    checkAndPrev() {  
      // 同上，但这里是切换到上一张  
      this.$refs.carousel.next();  
    },
  },  
};
</script>

<style lang="scss" scoped>
::v-deep .el-carousel__container{
  height: 100% !important;
}

img {
  width: 100%;
  height: auto;
}

/* .el-header {
  position: absolute;
} */
.swiper-slide {
  font-size: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;

    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
     font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}

/* //经典案例 */
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}

/* //经典案例hover */
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }

  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }

  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;

    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
.el-carousel__container{
  height: 100% !important;
}
</style>